/* JYG - The Fish Box | Subscription selector (sections/jyg-fishbox-selector.liquid)
   Category -> box -> plan. Adds to cart with the Kaching (native) selling plan. */
(function () {
  'use strict';
  var TRUCK = '<svg viewBox="0 0 20 14" width="15" height="11" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M1 1h11v9H1zM12 4h4l3 3v3h-7z"/><circle cx="5" cy="11.5" r="1.6" fill="#fff"/><circle cx="15" cy="11.5" r="1.6" fill="#fff"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function show(el, on) { if (el) el.style.display = on ? '' : 'none'; }
  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, window.theme && theme.moneyFormat || '${{amount}}'); } catch (e) {}
    }
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function short(n) { return String(n || '').replace(/\s+plan$/i, ''); }
  function months(p) { return p.perBoxRaw > 0 ? Math.max(1, Math.round(p.chargeRaw / p.perBoxRaw)) : 1; }
  function parseExample(str) {
    var out = {};
    String(str || '').split(',').forEach(function (part) {
      var i = part.lastIndexOf(':');
      if (i < 0) return;
      var k = part.slice(0, i).trim().toUpperCase(), n = parseInt(part.slice(i + 1), 10);
      if (k && n > 0) out[k] = n;
    });
    return out;
  }
  function flash(el, cls) { if (!el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }

  function Selector(root) {
    this.root = root;
    var raw = root.querySelector('[data-fb-data]');
    if (!raw) return;
    try { this.data = JSON.parse(raw.textContent); } catch (e) { console.error('[fishbox] bad JSON', e); return; }
    this.boxes = this.data.boxes || [];
    if (!this.boxes.length) return;
    this.L = this.data.labels || {};
    this.cat = null; this.box = null; this.plan = null; this.lastBox = null; this.touched = false;
    this.q = function (s) { return root.querySelector(s); };
    this.bind();
    var firstCat = root.querySelector('[data-fb-cat]');
    this.setCat(this.catFromUrl() || (firstCat ? firstCat.getAttribute('data-fb-cat') : this.boxes[0].cat), true);
    this.initSticky();
  }

  // ?category=jigs | inshore | swym  (also ?box=...) opens the selector on that category
  Selector.prototype.catFromUrl = function () {
    var q = '';
    try { var u = new URLSearchParams(window.location.search); q = (u.get('category') || u.get('box') || '').trim().toUpperCase(); } catch (e) {}
    if (!q) return null;
    var alias = { JIGS: 'JYGS', JIG: 'JYGS', JYG: 'JYGS', SWIM: 'SWYM', SWIMBAITS: 'SWYM' };
    q = alias[q] || q;
    var cats = this.boxes.map(function (b) { return b.cat; });
    for (var i = 0; i < cats.length; i++) if (String(cats[i]).toUpperCase() === q) return cats[i];
    return null;
  };
  Selector.prototype.boxById = function (id) {
    for (var i = 0; i < this.boxes.length; i++) if (this.boxes[i].id === id) return this.boxes[i];
    return null;
  };
  Selector.prototype.boxesOf = function (cat) {
    return this.boxes.filter(function (b) { return !cat || b.cat === cat; });
  };
  Selector.prototype.pickForCategory = function (cat) {
    var list = this.boxesOf(cat);
    return list.filter(function (b) { return b.badge && b.available; })[0] ||
      list.filter(function (b) { return b.available; })[0] || list[0] || null;
  };

  Selector.prototype.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-fb-cat]'), b = e.target.closest('[data-fb-box]'), p = e.target.closest('[data-fb-plan-id]');
      if (c) { self.touched = true; self.setCat(c.getAttribute('data-fb-cat')); }
      else if (b) { self.touched = true; self.setBox(b.getAttribute('data-fb-box')); }
      else if (p) { self.touched = true; self.plan = p.getAttribute('data-fb-plan-id'); self.render(); }
    });
    var form = this.q('[data-fb-form]');
    if (form) form.addEventListener('submit', function (e) { self.submit(e, form); });
  };

  Selector.prototype.setCat = function (cat, silent) {
    this.cat = cat;
    this.root.querySelectorAll('[data-fb-cat]').forEach(function (el) {
      el.setAttribute('aria-pressed', el.getAttribute('data-fb-cat') === cat ? 'true' : 'false');
    });
    this.root.querySelectorAll('[data-fb-box]').forEach(function (el) {
      show(el, !cat || el.getAttribute('data-fb-of-cat') === cat);
    });
    var cur = this.box && this.boxById(this.box);
    if (!cur || cur.cat !== cat) { var pick = this.pickForCategory(cat); this.box = pick && pick.id; }
    this.render(silent);
  };
  Selector.prototype.setBox = function (id) { this.box = id; this.render(); };

  Selector.prototype.render = function () {
    var b = this.boxById(this.box);
    if (!b) return;
    var L = this.L, self = this;
    this.root.querySelectorAll('[data-fb-box]').forEach(function (el) {
      el.setAttribute('aria-pressed', el.getAttribute('data-fb-box') === b.id ? 'true' : 'false');
    });

    // Plans (keep the same plan name across boxes when possible)
    var plans = b.plans || [];
    var prevName = null;
    if (this.planObj) prevName = this.planObj.name;
    var plan = plans.filter(function (p) { return String(p.id) === String(self.plan); })[0] ||
      plans.filter(function (p) { return p.name === prevName; })[0] || plans[0] || null;
    this.plan = plan ? String(plan.id) : null;
    this.planObj = plan;

    var plansEl = this.q('[data-fb-plans]');
    if (plansEl) {
      plansEl.innerHTML = plans.map(function (p) {
        var off = b.basePriceRaw > 0 ? Math.round((1 - p.perBoxRaw / b.basePriceRaw) * 100) : 0;
        var free = self.data.freeMin > 0 && p.chargeRaw >= self.data.freeMin;
        return '<button type="button" class="fb-opt" data-fb-plan-id="' + esc(p.id) + '" aria-pressed="' + (p === plan) + '">' +
          (off > 0 ? '<span class="fb-badge">' + esc((L.save || 'Save {n}%').replace('{n}', off)) + '</span>' : '') +
          '<span class="fb-opt__t">' + esc(short(p.name)) + '</span>' +
          '<span class="fb-opt__p">' + (off > 0 ? '<s>' + esc(b.basePrice) + '</s> ' : '') + esc(p.perBox) + '</span>' +
          (free ? '<span class="fb-opt__ship">' + TRUCK + ' ' + esc(L.freeShip) + '</span>' : '') +
          '</button>';
      }).join('');
      var stepEl = plansEl.closest('.fb-sel__step');
      show(stepEl, plans.length > 0);
    }

    this.renderInbox(b);

    // Summary
    var img = this.q('[data-fb-img]');
    if (img) {
      if (b.img) {
        if (img.getAttribute('src') !== b.img.src) { img.src = b.img.src; img.srcset = b.img.srcset || ''; img.sizes = '(max-width: 900px) 40vw, 360px'; }
        img.alt = b.img.alt || b.title; img.hidden = false; img.style.display = '';
      } else { img.style.display = 'none'; }
    }
    var setTxt = function (sel, t) { var el = self.q(sel); if (el) el.textContent = t || ''; return el; };
    var nameEl = setTxt('[data-fb-name]', b.title);
    setTxt('[data-fb-desc]', b.desc);
    var rows = { qty: b.qty, range: b.range, rig: b.rig, plan: plan ? short(plan.name) : '' };
    var m = plan ? months(plan) : 1;
    var free = plan && this.data.freeMin > 0 && plan.chargeRaw >= this.data.freeMin;
    Object.keys(rows).forEach(function (k) {
      var dd = self.q('[data-fb-v="' + k + '"]'); if (dd) dd.textContent = rows[k] || '';
      show(self.q('[data-fb-row="' + k + '"]'), !!rows[k]);
    });
    var ship = this.q('[data-fb-v="ship"]');
    if (ship) ship.innerHTML = free ? '<b class="fb-free">' + esc(L.shipFree) + '</b>' : esc(L.shipPaid);
    show(this.q('[data-fb-row="ship"]'), !!plan);
    var charge = this.q('[data-fb-v="charge"]');
    if (charge) charge.textContent = plan ? (m > 1 ? plan.charge + ' ' + (L.everyN || '').replace('{n}', m) : plan.charge + ' ' + (L.once || '')) : '';
    show(this.q('[data-fb-row="charge"]'), !!plan);

    var bb = setTxt('[data-fb-bbname]', b.title + (plan ? ' · ' + short(plan.name) : ''));
    setTxt('[data-fb-perbox]', (plan ? plan.perBox : b.basePrice) + (L.perMonth || ''));

    if (this.lastBox !== null && this.lastBox !== b.id) {
      flash(img, 'fb-chg-img'); flash(nameEl, 'fb-chg-name'); flash(bb, 'fb-chg-name');
    }
    this.lastBox = b.id;

    // Form
    var v = this.q('[data-fb-variant]'), sp = this.q('[data-fb-plan]'), btn = this.q('[data-fb-submit]');
    if (v) v.value = b.variantId;
    if (sp) sp.value = plan ? plan.id : '';
    if (btn) { btn.disabled = !b.available; btn.textContent = b.available ? L.btn : L.soldOut; }

    this.syncStickyText();
  };

  Selector.prototype.renderInbox = function (b) {
    var el = this.q('[data-fb-inbox]');
    if (!el) return;
    var L = this.L;
    var fams = (this.data.families || []).filter(function (f) { return f.cat === b.cat; });
    if (!fams.length) { el.innerHTML = ''; el.style.display = 'none'; return; }
    el.style.display = '';
    var ex = parseExample(b.example), total = 0, hasEx = Object.keys(ex).length > 0;
    Object.keys(ex).forEach(function (k) { total += ex[k]; });
    var unit = String(b.qty || '').trim().split(/\s+/).pop();
    var note = (b.note && String(b.note).trim()) || '';
    var why = String(L.note || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
    if (hasEx) {
      // circles that land in this example month first, greyed ones last (stable order)
      fams = fams.map(function (f, i) { return { f: f, i: i, on: ex[String(f.name || '').trim().toUpperCase()] ? 0 : 1 }; })
        .sort(function (a, b) { return a.on - b.on || a.i - b.i; }).map(function (x) { return x.f; });
    }
    var circles = fams.map(function (f) {
      var n = ex[String(f.name || '').trim().toUpperCase()] || 0;
      var off = hasEx && !n;
      return '<div class="fb-ib' + (off ? ' fb-ib--off' : '') + '" style="--fb-ib-scale:' + (f.scale || 80) + '%">' +
        (n ? '<span class="fb-badge">×' + n + '</span>' : '') +
        '<span class="fb-ib__disc">' + (f.img ? '<img src="' + esc(f.img) + '" alt="" loading="lazy" width="100" height="100">' : '') + '</span>' +
        '<span class="fb-ib__n">' + esc(f.name) + '</span></div>';
    }).join('');
    el.innerHTML =
      '<div class="fb-inbox__head"><b>' + esc(L.inboxTitle) + '</b>' +
      (b.qty ? '<span class="fb-inbox__qty">' + esc(b.qty + (L.inboxSuffix ? ' ' + L.inboxSuffix : '')) + '</span>' : '') +
      (L.inboxDrawn ? '<span>' + esc(L.inboxDrawn) + '</span>' : '') + '</div>' +
      '<div class="fb-inbox__row">' + circles + '</div>' +
      ((hasEx || note) ? '<p class="fb-inbox__note">' + (hasEx ? '<b>' + esc(L.example) + '</b> ' + total + ' ' + esc(unit) + '. ' : '') + esc(note) + '</p>' : '') +
      (why.length ? '<ul class="fb-inbox__why">' + why.map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') + '</ul>' : '');
  };

  Selector.prototype.submit = function (e, form) {
    var self = this, btn = this.q('[data-fb-submit]');
    if (this.root.getAttribute('data-cart-behavior') !== 'ajax' || !window.fetch) return; // normal form post
    e.preventDefault();
    var b = this.boxById(this.box);
    if (!b || !b.available) return;
    var item = { id: b.variantId, quantity: 1 };
    if (this.plan) item.selling_plan = Number(this.plan);
    if (btn) btn.disabled = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        if (btn) btn.disabled = false;
      })
      .catch(function () { if (btn) btn.disabled = false; form.submit(); });
  };

  Selector.prototype.initSticky = function () {
    var st = this.q('[data-fb-sticky]');
    if (!st) return;
    this.sticky = st;
    document.body.appendChild(st); // fixed bar must not be clipped by section transforms
    var self = this, root = this.root;
    var cta = st.querySelector('[data-fb-st-cta]');
    if (cta) cta.addEventListener('click', function (e) {
      if (!self.touched) return; // just scroll to the selector
      e.preventDefault();
      var btn = self.q('[data-fb-submit]');
      if (btn && !btn.disabled) btn.click();
    });
    var sync = function () {
      if (!document.body.contains(root)) { st.remove(); window.removeEventListener('scroll', sync); return; }
      var on = root.getBoundingClientRect().bottom < 0;
      st.classList.toggle('is-on', on);
      st.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (cta) cta.tabIndex = on ? 0 : -1;
    };
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  };
  Selector.prototype.syncStickyText = function () {
    var st = this.sticky || this.q('[data-fb-sticky]');
    if (!st) return;
    var L = this.L, b = this.boxById(this.box), p = this.planObj;
    var lab = st.querySelector('[data-fb-st-label]'), pr = st.querySelector('[data-fb-st-price]'), cta = st.querySelector('[data-fb-st-cta]');
    if (this.touched && b) {
      if (lab) lab.textContent = b.title;
      if (pr) pr.textContent = (p ? p.perBox : b.basePrice) + (L.perMonth || '');
      if (cta) cta.textContent = b.available ? L.btn : L.soldOut;
    } else {
      var cheapest = this.boxes.reduce(function (a, x) { return (!a || x.basePriceRaw < a.basePriceRaw) ? x : a; }, null);
      if (lab) lab.textContent = L.from || '';
      if (pr) pr.textContent = (cheapest ? cheapest.basePrice : '') + (L.perMonth || '');
      if (cta) cta.textContent = L.stChoose || '';
    }
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-jyg-fbsel]').forEach(function (el) {
      if (el.__fbsel) return;
      el.__fbsel = new Selector(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () {
    document.querySelectorAll('body > [data-fb-sticky]').forEach(function (s) { s.remove(); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest && e.target.closest('[data-fb-box]');
    var root = el && el.closest('[data-jyg-fbsel]');
    if (root && root.__fbsel) { var id = el.getAttribute('data-fb-box'); var b = root.__fbsel.boxById(id); if (b) { root.__fbsel.setCat(b.cat); root.__fbsel.setBox(id); } }
  });
})();
